import { AvField, AvForm } from "availity-reactstrap-validation"
import MetaTag from "components/Common/Meta-tag"
import { debounce, map, range } from "lodash"
import MyPagination from "components/Common/MyPagination"
import React, { useEffect, useState } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap"
import { getAllFormattedEarnings } from "store/actions"
import Breadcrumbs from "../../../components/Common/Breadcrumb"

function FormattedEarnings() {
  const dispatch = useDispatch()
  const [finalDateFormated, setFinalDateFormated] = useState({
    from: "",
    to: "",
  })
  const [page, setPage] = useState(1)
  const [orderSearchText, setOrderSearchText] = useState("")
  const [totalItemLimit, setTotalItemLimit] = useState(10)

  const { loading, formattedEarnings, total } = useSelector(state => ({
    loading: state.Users.loading,
    formattedEarnings: state.Users.formattedEarnings,
    total: state?.Users?.formattedEarnings?.total,
  }))

  const totalPages = Math.ceil(total / 10)
  const pages = range(1, totalPages + 1)

  const handleDateSearch = () => {
    if (
      finalDateFormated?.from?.length >= 1 &&
      finalDateFormated?.to?.length >= 1
    ) {
      return finalDateFormated
    } else {
      return {
        from: "",
        to: "",
      }
    }
  }

  const columns = [
    {
      dataField: "ref_id",
      text: "Refferal ID",
      sort: true,
    },
    {
      dataField: "promoterName",
      text: "Promoter ",
      sort: true,
    },

    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "count",
      text: "Rewards Amount",
      sort: true,
    },
    {
      dataField: "amount",
      text: "Rewards Count",
      sort: true,
    },
  ]

  const pageViews = map(formattedEarnings?.formattedData, (item, index) => ({
    ...item,
    ref_id: (
      <span>
        <h6 className="text-primary">{item?.ref_id}</h6>
      </span>
    ),
    promoterName: (
      <span>
        <h6>{item?.promoterName}</h6>
      </span>
    ),
    phone: (
      <span>
        <h6>{item?.promoterPhone}</h6>
      </span>
    ),
    count: (
      <span>
        <h6>{item?.totalEarningsAmount}</h6>
      </span>
    ),
    amount: (
      <span>
        <h6>{item?.totalEarningsCount}</h6>
      </span>
    ),
  }))
  useEffect(() => {
    dispatch(
      getAllFormattedEarnings(
        page,
        totalItemLimit,
        orderSearchText,
        handleDateSearch()
      )
    )
  }, [dispatch, page, orderSearchText, totalItemLimit, finalDateFormated])
  const handleTableChange = (type, { page, searchText }) => {
    setShopList(
      zshops.filter(zshop =>
        Object.keys(zshop).some(key =>
          zshop[key].toLowerCase().includes(searchText.toLowerCase())
        )
      )
    )
  }
  const listChange = sortValue => {
    setSort(sortValue)
  }
  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
    }
  }
  const debounceOrderSearch = debounce(value => setOrderSearchText(value), 600)

  return (
    <div>
      <MetaTag title={"All Formatted Rewards"} />
      <div className="page-content">
        <Breadcrumbs title="Promoters" breadcrumbItem="All Formatted Rewards" />
        <Container fluid>
          <div className="container-fluid">
            <Row>
              <Col className="col-12">
                <Card className="pt-3">
                  <CardBody>
                    <ToolkitProvider
                      keyField="_id"
                      columns={columns}
                      data={pageViews}
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <></>
                            <Col className="col-12 d-flex align-items-center mb-3">
                              <div className="search-box ms-2 d-inline-block">
                                <div className="position-relative">
                                  <AvForm>
                                    <AvField
                                      name="searchText"
                                      placeholder="Search"
                                      type="text"
                                      onChange={e =>
                                        debounceOrderSearch(e.target.value)
                                      }
                                    />
                                  </AvForm>
                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>

                              <AvForm className="form-horizontal mx-3 d-flex align-items-center">
                                <div className="mx-1">
                                  <span className="">
                                    Show
                                    <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                                  </span>
                                </div>
                                <div className="" style={{ width: "50px" }}>
                                  <AvField
                                    name="pageLimit"
                                    className="form-control"
                                    value={totalItemLimit}
                                    onChange={e => handlePageLimit(e)}
                                    type="text"
                                    required
                                  />
                                </div>
                              </AvForm>
                              <div className=" d-flex align-items-center ">
                                <p
                                  className="mb-0 pb-0 mx-2"
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Sort By Date :
                                </p>
                                <AvForm>
                                  <div className="d-flex date_wrapper ">
                                    <div className="d-flex align-items-start position-relative ">
                                      <AvField
                                        className="cursor"
                                        name="dateRange"
                                        type="date"
                                        validate={{
                                          dateRange: {
                                            start: {
                                              value: -5,
                                              units: "years",
                                            },
                                            end: { value: 5, units: "years" },
                                          },
                                        }}
                                        onChange={e =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            from: e.target.value,
                                          })
                                        }
                                        value={finalDateFormated?.from}
                                      />
                                      <button
                                        onClick={() =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            from: "",
                                          })
                                        }
                                        type="button"
                                        className="btn btn-white editable-cancel date_close btn-sm"
                                      >
                                        <i className="mdi mdi-close text-danger "></i>
                                      </button>
                                    </div>
                                    <div className="d-flex align-items-start position-relative">
                                      <AvField
                                        name="dateRange"
                                        className="mx-1 cursor"
                                        type="date"
                                        validate={{
                                          dateRange: {
                                            start: {
                                              value: -5,
                                              units: "years",
                                            },
                                            end: { value: 5, units: "years" },
                                          },
                                        }}
                                        onChange={e =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            to: e.target.value,
                                          })
                                        }
                                        value={finalDateFormated?.to}
                                      />
                                      <button
                                        onClick={() =>
                                          setFinalDateFormated({
                                            ...finalDateFormated,
                                            to: "",
                                          })
                                        }
                                        type="button"
                                        className="btn btn-white editable-cancel date_close btn-sm"
                                      >
                                        <i className="mdi mdi-close text-danger "></i>
                                      </button>
                                    </div>
                                  </div>
                                </AvForm>
                              </div>
                            </Col>
                          </Row>
                          {loading ? (
                            <Spinner
                              color="secondary"
                              className="d-block m-auto"
                            />
                          ) : (
                            <>
                              {formattedEarnings?.total === 0 ? (
                                <p className="my-2 mx-3 ">
                                  No formatted rewards!
                                </p>
                              ) : (
                                <Row>
                                  <p>
                                    Total :&nbsp;
                                    {formattedEarnings?.total}{" "}
                                  </p>

                                  <Col xl="12">
                                    <div className="table-responsive">
                                      <BootstrapTable
                                        // keyField={"id"}
                                        key={"id"}
                                        responsive
                                        bordered={false}
                                        striped={false}
                                        // defaultSorted={defaultSorted}
                                        // selectRow={selectRow}
                                        classes={
                                          "table align-middle table-nowrap"
                                        }
                                        headerWrapperClasses={"thead-light"}
                                        {...toolkitProps.baseProps}
                                        onTableChange={handleTableChange}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              )}
                              <MyPagination
                                totalPages={pages}
                                page={page}
                                setPage={setPage}
                              />
                            </>
                          )}
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default FormattedEarnings
